module.exports = __webpack_public_path__ + "fonts/oktaVerify_38x38.ec588b98b16b2ddd8a0256ffbc3bab88.png?";


//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-signin-widget/dist/img/icons/mfa/oktaVerify_38x38.png
// module id = 291
// module chunks = 9